<!--
Author: Lsc
Date: 2019-07-25
Desc: 上传证件ocr验证
 -->
<template>
    <div class="ocr-upd comp">
        <el-dialog
            v-loading="load"
            class="prop"
            :title="title"
            :visible="visible"
            :width="width"
            :before-close="dialogClose"
        >
            <div class="ocr-upd-tip">
                <img src="@/assets/img/icon-warning.png" alt="" />
                <span>
                    单张图片大小不得超过{{
                        $cache.getOcrFileSize()
                    }}M，且仅支持BMP、JPG、JPEG、PNG格式。
                </span>
            </div>
            <el-row class="up-list-ocr-dialog" :span="24">
                <el-tabs v-model="activeTab" v-if="isShowWechatScan">
                    <el-tab-pane label="微信上传" name="wechat">
                        <div class="tips">
                            根据《金融机构客户身份证识别和客户身份资料及交易记录保存管理办法》相关规定，为了您的账户安全，请上传开户证件照，本次操作预计可在20秒内完成，{{
                                $cache.getCompanyInfoParam("10101014")
                            }}保障您的隐私安全，信息仅用于身份验证。
                        </div>
                        <wx-scan-upload
                            :cert-type="certType"
                            :is-show="activeTab === 'wechat'"
                            v-on:wxSuccess="wxScanSuccess"
                            v-on:cancel="dialogClose"
                        ></wx-scan-upload>
                    </el-tab-pane>
                    <el-tab-pane label="电脑上传" name="local"></el-tab-pane>
                </el-tabs>
                <div v-if="(isShowWechatScan && activeTab === 'local') || !isShowWechatScan">
                    <div :class="{ tips: true, 'tips-margin': !isShowWechatScan }">
                        根据《金融机构客户身份证识别和客户身份资料及交易记录保存管理办法》相关规定，为了您的账户安全，请上传开户证件照，本次操作预计可在20秒内完成，{{
                            $cache.getCompanyInfoParam("10101014")
                        }}保障您的隐私安全，信息仅用于身份验证。
                    </div>
                    <el-form :model="img">
                        <el-form-item label="">
                            <div class="img-up-box">
                                <div class="img-up-list el-upload-list--picture-card">
                                    <div
                                        v-if="imgBase64.backImage"
                                        class="el-upload-list__item-actions"
                                    >
                                        <i
                                            class="el-icon-delete"
                                            aria-hidden="true"
                                            v-on:click="delImg('backImage')"
                                        />
                                    </div>
                                    <el-input
                                        v-model="img.backImage"
                                        type="file"
                                        name="backImage"
                                        :accept="accept"
                                        v-on:change="getImgBase"
                                    />
                                    <div class="img-up img-load-status">
                                        <img
                                            v-if="imgBase64.backImage"
                                            :src="imgBase64.backImage"
                                            alt=""
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/img/ocrback.png')"
                                            alt=""
                                        />
                                    </div>
                                    <span>{{ $cache.getDict("130007", certType) }}人像面</span>
                                </div>
                                <div class="img-up-list el-upload-list--picture-card">
                                    <div
                                        v-if="imgBase64.faceImage"
                                        class="el-upload-list__item-actions"
                                    >
                                        <i
                                            class="el-icon-delete"
                                            aria-hidden="true"
                                            v-on:click="delImg('faceImage')"
                                        />
                                    </div>
                                    <el-input
                                        v-model="img.faceImage"
                                        type="file"
                                        name="faceImage"
                                        :accept="accept"
                                        v-on:change="getImgBase"
                                    />
                                    <div class="img-up img-load-status">
                                        <img
                                            v-if="imgBase64.faceImage"
                                            :src="imgBase64.faceImage"
                                            alt=""
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/img/ocrover.png')"
                                            alt=""
                                        />
                                    </div>
                                    <span>{{ $cache.getDict("130007", certType) }}国徽面</span>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="" class="btn-center">
                            <el-button class="medium dc-cancel-btn" v-on:click="dialogClose">
                                还未准备好
                            </el-button>
                            <el-button
                                type="primary"
                                class="medium confirm"
                                :disabled="btnStatus"
                                v-on:click="submitInfo()"
                            >
                                确定上传
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="cut-off-line top">
                    <span>请按正确示例上传证件照</span>
                </div>
                <img src="@/assets/img/ocr-example.png" class="example" alt="" />
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import commonApi from "@/api/common";
import userApi from "@/api/user";
import WxScanUpload from "./wxScanUpload.vue";

export default {
    name: "OrcUpdDialog",
    components: { WxScanUpload },
    props: {
        title: {
            type: String,
            default: "上传证件照"
        },
        width: {
            type: String,
            default: "740px"
        },
        visible: {
            type: Boolean,
            default: false
        },
        certType: {
            type: String,
            default: "00"
        },
        from: {
            type: String,
            default: ""
        },
        checkFlag: {
            type: String,
            default: "0"
        },
        skipOpenAcctCheck: {
            type: Boolean,
            default: false // 默认还是走原来的逻辑
        },
        minorAllowOpen: {
            type: Boolean,
            default: false // 是否允许未成年人开户
        }
    },
    data() {
        return {
            load: false,
            dialogImageUrl: "",
            activeTab: "wechat",
            accept: "image/bmp,image/png,image/jpg,image/jpeg",
            img: {
                faceImage: "",
                backImage: ""
            },
            imgBase64: {
                faceImage: "",
                backImage: ""
            },
            isShowWechatScan: false
        };
    },
    computed: {
        btnStatus: function () {
            return !(this.imgBase64.faceImage && this.imgBase64.backImage);
        }
    },
    watch: {},
    mounted() {
        this.isShowWechatScan =
            this.$cache.getCompanyInfoParam("10301003") &&
            this.$cache.getCompanyInfoParam("10301003").indexOf("T05") > -1;
    },
    methods: {
        dialogClose() {
            this.$emit("back");
            this.cancel();
        },
        async wxScanSuccess(data) {
            const ocrResult = data.ocrResult;
            // 微信上传成功后，复用相同的校验和提交流程
            await this.handleOcrResult(ocrResult, "wechat");
        },
        async submitInfo() {
            const params = {
                frontphoto: this.imgBase64.faceImage.split(",")[1],
                backphoto: this.imgBase64.backImage.split(",")[1],
                photo: this.imgBase64.backImage.split(",")[1],
                mode: "1",
                type: this.certType,
                checkflag: this.checkFlag
            };
            this.load = true;
            try {
                const resp = await commonApi[this.certType === "00" ? "ocr" : "fOcr"](params);
                this.load = false;
                if (resp.error) return;
                await this.handleOcrResult(resp.data);
            } catch (error) {
                this.load = false;
            }
        },
        // 处理 OCR 识别结果（公共校验和提交流程）
        async handleOcrResult(ocrData, source) {
            if (!ocrData) return;

            // 校验 OCR 识别结果是否有效（关键字段是否为空）
            if (!ocrData.certificateno && !ocrData.custname && !ocrData.chinesename) {
                this.$message({
                    type: "warning",
                    message: "证件识别失败，请重新上传清晰的证件照片"
                });
                return;
            }
            // 身份证有效期校验
            if ((this.certType === "00" || this.certType === "0B") && ocrData.isexpired === "1") {
                this.$message({
                    type: "warning",
                    message: "身份证已过有效期，请上传有效证件"
                });
                return;
            }
            // OCR日期格式校验（有效期 + 出生日期）
            const validateDate = ocrData.validate;
            const birthdayDate = this.$util.normalizeOcrDate(ocrData.birthday || ocrData.birthdate);
            if (
                !this.$util.isValidOcrDate(validateDate) ||
                !this.$util.isValidOcrDate(birthdayDate)
            ) {
                this.$message({
                    type: "warning",
                    message: "请上传正确的证件照片"
                });
                return;
            }
            if (
                !this.skipOpenAcctCheck &&
                !this.$cache.getBinded() &&
                this.certType === "00" &&
                ocrData.isopenacct == "1"
            ) {
                this.$message({
                    type: "warning",
                    message: "证件号码已经开户"
                });
                return;
            }
            if (ocrData.isexpired == "1") {
                const msg = "您的" + this.$cache.getDict("130007", this.certType) + "有效期已过期";
                this.$message({
                    type: "warning",
                    message: msg
                });
                return;
            }

            // BUG-14766: 未成年人拦截 - 在上传身份证时拦截
            // 检查是否未成年人（未满18岁），只有在不允许未成年人开户时才拦截
            if (!this.minorAllowOpen && birthdayDate) {
                const _date = this.$util.getBeginDate(
                    new Date().toISOString().slice(0, 10).replace(/-/g, ""),
                    18,
                    true
                );
                if (Number(birthdayDate) >= Number(_date)) {
                    // 根据场景区分提示信息
                    const msg =
                        this.from === "userInfo"
                            ? "未成年人不支持修改证件信息"
                            : "未成年人暂不支持开户";
                    this.$message({
                        type: "warning",
                        message: msg
                    });
                    return;
                }
            }
            if (this.from === "userInfo") {
                if (ocrData.certificateno.length !== 18) {
                    this.$message({
                        type: "warning",
                        message: "请提交 18 位的证件号"
                    });
                    return;
                }
                const param = {
                    newcertificateno: ocrData.certificateno,
                    newcustname:
                        this.certType === "0B" && ocrData.chinesename
                            ? ocrData.chinesename
                            : ocrData.custname
                };
                let verifyRes = await userApi.verifyService(param);
                let msg = "";
                if (verifyRes.data) {
                    if (verifyRes.data.nameflag !== "1") {
                        msg = "姓名";
                    } else if (verifyRes.data.certflag !== "1") {
                        msg = "证件号码";
                    }
                }
                if (msg) {
                    this.$message({
                        type: "warning",
                        message: msg + "不可变更，如需修改请联系客服处理"
                    });
                    return;
                }
            }

            // 自然人核验：OCR识别证通厂商核验自然人信息
            if (source !== "wechat") {
                this.load = true;
                const naturalPassed = await this.naturalPersonVerify(
                    ocrData,
                    this.certType,
                    this.imgBase64.backImage
                );
                this.load = false;
                if (!naturalPassed) return;
            }

            this.$emit("success", {
                ...ocrData,
                vailddate: this.normalizeValidate(ocrData.validate)
            });
            this.dialogClose();
            this.$message({
                type: "success",
                message: "上传证件成功！"
            });
        },
        /**
         * 自然人核验
         * 在OCR上传证件照后、满足条件时调用，核验不通过会弹窗阻拦后续流程
         *
         * 触发条件：
         *   - 证件类型为"0B"（永居证）
         *   - OEM模块列表(10301003)包含"AA9"
         *   - 自然人校验厂商(25041101)为"3"（证通）
         * 核验类型(26010902)：0-实名四要素, 1-实人全要素
         *
         * @param {Object} ocrData - OCR返回的证件信息
         * @param {String} certType - 证件类型（"00"-身份证, "0B"-永居证）
         * @param {String} faceImageBase64 - 人脸正面照base64（含 data:image/xxx;base64, 前缀）
         * @returns {Promise<Boolean>} true-核验通过或无需核验, false-核验被阻拦
         */
        async naturalPersonVerify(ocrData, certType, faceImageBase64) {
            // 仅永居证("0B")才触发自然人核验
            if (certType !== "0B") return true;
            const oemModules = this.$cache.getCompanyInfoParam("10301003");
            const authVendor = this.$cache.getCompanyInfoParam("25041101");
            // 条件判断：OEM模块列表包含"AA9" 且 自然人校验厂商为"3"（证通）才触发核验
            if (!oemModules || !oemModules.includes("AA9")) return true;
            if (authVendor !== "3") return true;
            const verifyType = this.$cache.getCompanyInfoParam("26010902"); // 核验类型
            const certName =
                certType === "0B" && ocrData.chinesename ? ocrData.chinesename : ocrData.custname;
            const nationality = ocrData.nation || ""; // 永居证用OCR返回的nation
            const certNo = ocrData.certificateno || "";
            let params = {};
            if (verifyType === "0") {
                // 实名四要素：姓名、证件号、证件类型、国别
                params = {
                    relationname: certName,
                    certificateno: certNo,
                    certificatetype: certType,
                    relationnationality: nationality,
                    relationtype: "0"
                };
            } else {
                // 实人全要素（含 verifyType 为空兜底）：姓名、性别、出生日期、国别、证件号、证件有效期、证件类型、人脸正面照
                const birthdate = this.$util.normalizeOcrDate(
                    ocrData.birthday || ocrData.birthdate || ""
                );
                const validdate = this.normalizeValidate(ocrData.validate);
                const faceimagepath = faceImageBase64 ? faceImageBase64.split(",")[1] : "";
                params = {
                    relationname: certName,
                    sex: ocrData.sex || "",
                    birthdate: birthdate,
                    relationnationality: nationality,
                    certificateno: certNo,
                    validdate: validdate,
                    certificatetype: certType,
                    faceimagepath: faceimagepath,
                    relationtype: "0"
                };
            }
            try {
                const res = await userApi.combPersonAuth(params);
                if (res.error) {
                    return false;
                }
                if (res.data && res.data.status === "1") {
                    // 核验通过
                    return true;
                } else {
                    this.$alert(
                        (res.data && res.data.message) || "自然人核验未通过，请核对证件信息",
                        "温馨提示",
                        {
                            confirmButtonText: "确定",
                            type: "warning"
                        }
                    );
                    return false;
                }
            } catch (e) {
                return false;
            }
        },
        cancel() {
            this.img = {
                faceImage: "",
                backImage: ""
            };
            this.imgBase64 = {
                faceImage: "",
                backImage: ""
            };
        },
        getImgBase() {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            let maxSize = this.$cache.getOcrFileSize();
            if (file.size > 1024 * 1024 * maxSize) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return;
            }
            for (var i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop()) k++;
            }
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg(index) {
            this.imgBase64[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
            }
        },
        // 处理有效期字段返回
        normalizeValidate(val) {
            if (!val) return "";

            // 统一转字符串，避免数字/字符串混用
            const str = String(val).trim();

            // 各种“长期”兜底
            if (str === "长期" || str === "长期有效" || str === "99991231") {
                return "99991231";
            } else {
                return str;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog__wrapper.prop .el-dialog__body) {
    padding: 0;
}

.ocr-upd-tip {
    background: #fffaf6;
    height: 40px;
    display: flex;
    align-items: center;
    color: var(--color-text-accent);
    font-size: 14px;
    img {
        width: 18px;
        height: 18px;
        margin: 0 8px 0 20px;
    }
}

.up-list-ocr-dialog {
    padding: 0 20px;
    :deep(.el-tabs__nav-scroll) {
        display: flex;
        justify-content: center;
    }
    :deep(.el-tabs__nav-wrap::after) {
        display: none;
    }
    .tips {
        padding: 0 20px;
        font-size: 14px;
        color: var(--color-text-primary);
        line-height: 22px;
    }

    .tips-margin {
        margin-top: 15px;
    }
    .img-up-list {
        margin: 50px 0px 30px;
        display: inline-block;
        position: relative;
        .el-upload-list__item-actions {
            z-index: 100;
            i {
                font-size: $f24;
                cursor: pointer;
            }
            i:last-of-type {
                margin-left: 20px;
            }
        }
        .el-input {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: 10;
        }
        .img-up,
        :deep(.el-input .el-input__inner) {
            width: 320px;
            height: 182px;
            line-height: 182px;
            cursor: pointer;
        }

        .img-up {
            text-align: center;
            border: 3px dashed $border-color4;
            border-radius: 10px;
            background-color: $bg1;
            overflow: hidden;
            img {
                width: 320px;
                height: 182px;
                display: inline-block;
            }
            &.img-load-status {
                width: 320px;
                height: 182px;
                border: none;
                border-radius: 6px;
            }
        }
        .img-text {
            vertical-align: middle;
            font-size: $f20;
        }
        .el-icon-plus {
            vertical-align: middle;
            font-size: $f26;
            margin-right: 7px;
            color: inherit;
            font-weight: bold;
        }
    }
    .img-up-box {
        text-align: center;
        font-size: 16px;
        .img-up-list {
            vertical-align: middle;
            &:last-of-type {
                margin-left: 20px;
            }
        }
        span {
            margin-top: 12px;
            line-height: 16px;
            display: block;
        }
    }
    .el-form-item__error {
        top: 90%;
        left: 50%;
        -webkit-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .btn-center {
        text-align: center;
        .confirm {
            width: 180px;
            margin-left: 40px;
        }
    }
    .cut-off-line.top {
        margin: 38px 0 13px;
    }
    .example {
        margin: 0 auto 40px;
        display: block;
    }
}
</style>
